import IGeronimo from "../models/geronimo/IGeronimo.model";

export const GERONIMO = 'geronimo';

export const setParamsGeronimoInSession = (params: IGeronimo) => {
  sessionStorage.setItem(GERONIMO, JSON.stringify(params));
}

export const getParamsGeronimoInSession = (): string => {
  return sessionStorage.getItem(GERONIMO) ?? '';
}
